import axios from 'axios';

const updateSystemSettingsApi = async (token, values) => {
  try {
    const res = await axios.post('/Setting/update', values, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'applications/json',
        Authorization: 'Bearer ' + token,
        lang: 'ar'
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default updateSystemSettingsApi;
